// extracted by mini-css-extract-plugin
export default {"card":"CardImage_card__dLX9h","cardImage":"CardImage_cardImage__ARJYq","cardContent":"CardImage_cardContent__93Tvd","cardHr":"CardImage_cardHr__ecrhp"};